// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkedinOutlinedSvg from "@fishx/icons-svg/es/asn/LinkedinOutlined";
import FishxIcon from '../components/FishxIcon';

var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinOutlinedSvg
  }));
};

LinkedinOutlined.displayName = 'LinkedinOutlined';
export default React.forwardRef(LinkedinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LinkedinOutlined.js
// module id = 3056
// module chunks = 0